module.exports = __webpack_public_path__ + "img/winerack19.be69f6de.jpg";